import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-useless-escape */
import platform from '../../common/platform';
import jsBridge from '../jsBridgeOld';
import Cookie from '../../common/cookie';
import Request from '../../common/network';
import { isFunction, isDate, isDom, g, isString, isArray, isObject } from '../../common/base'; // 上报接口地址

var reportCgi = 'https://channel.haiwaioo.com/external/aci/main?sCloudApiName=ams.security.channeljs';
var reportRequestPool = {};

function getFormatDateTime(oDate) {
  if (!isDate(oDate)) {
    oDate = new Date(oDate);
  }

  return "".concat(Math.floor(oDate.getTime() / 1000));
  /* var arrDate=[oDate.getFullYear(),oDate.getMonth()+1,oDate.getDate()];
    var arrTime=[oDate.getHours(),oDate.getMinutes(),oDate.getSeconds()];
    for(var i=0;i<arrTime.length;i++){
        if(arrTime[i]<10){
            arrTime[i]='0'+arrTime[i];
        }
    }
    return arrDate.join('-') + ' '+arrTime.join(':');*/
}

var getEnviromentParams = function getEnviromentParams() {
  var envParams = {}; // 曝光时间 iscenepoptime

  if (window.performance && performance.timing && performance.timing.domComplete) {
    envParams.iscenepoptime = getFormatDateTime(performance.timing.domComplete);
  } else {
    envParams.iscenepoptime = getFormatDateTime(new Date());
  } // 平台 splatform


  envParams.splatform = platform.ios() ? 'ios' : platform.android() ? 'android' : 'unknown'; // 设备id sdeviceid

  envParams.sdeviceid = 'unknown'; // 手机品牌 vbrand

  if (platform.iphone()) {
    envParams.vbrand = 'iphone';
  } else if (platform.ipad()) {
    envParams.vbrand = 'ipad';
  } else if (platform.ipod()) {
    envParams.vbrand = 'ipod';
  } else {
    envParams.vbrand = 'other';
  } // 手机型号 vmodel


  envParams.vmodel = 'unknown'; // iphone型号获取较为麻烦，暂时不获取，后续可优化
  // 设备分辨率 resolution

  envParams.resolution = function () {
    var screen = window.screen ? window.screen : platform.screen();

    if (screen) {
      var width = Math.max(screen.width, screen.height);
      var height = Math.min(screen.width, screen.height);
      var ratio = window.devicePixelRatio ? window.devicePixelRatio : 1;
      width *= ratio;
      height *= ratio;
      return "".concat(width, "*").concat(height);
    }

    return 'unknown';
  }(); // 设备CPU cpu


  envParams.cpu = 'unknown'; // iphone的cpu获取较为麻烦，暂时不获取，后续可优化
  // 设备CPU核心数 cpucore

  envParams.cpucore = 'unknown'; // iphone的cpu核心数获取较为麻烦，暂时不获取，后续可优化
  // 设备GPU

  envParams.gpu = 'unknown'; // iphone的GPU获取较为麻烦，暂时不获取，后续可优化
  // 操作系统版本 osversion

  envParams.osversion = function () {
    var arrMatch = navigator.userAgent.match(/iPhone\s+OS\s+([\d\_]+)/);

    if (isArray(arrMatch)) {
      return arrMatch[1].replace(/\_/g, '.');
    }

    return 'unknown';
  }();

  return envParams;
};
/* 2 检查所有参数*/


var checkParams = function checkParams(_params, _appParams) {
  // 检查一些基本的渠道侧数据
  if (!_params.channel || !_params.ssceneid || !_params.sgameappid || !_params.packageid || !_params.suintype) {
    throw new Error('请传入渠道侧相关参数');
  }

  if (isObject(_appParams)) {
    // 检查app相关参数
    var envType = platform.isQQApp() ? 'qq' : platform.isWxApp() ? 'wx' : platform.isQQBrowser() ? 'qb' : 'others';

    if (/^(wx)$/.test(envType)) {
      if (!_appParams.appid || !_appParams.appid[envType]) {
        throw new Error("\u5F53\u524D\u73AF\u5883\u4E0B\uFF0C\u8BF7\u4F20\u5165\u6E38\u620F\u5728".concat(envType, "appid"));
      }
    }

    if (/^(wx|qq|qb)$/.test(envType)) {
      if (!_appParams.scheme || !_appParams.scheme[envType]) {
        throw new Error("\u5F53\u524D\u73AF\u5883\u4E0B\uFF0C\u8BF7\u4F20\u5165\u6E38\u620F\u5728".concat(envType, "\u5E73\u53F0\u4E0B\u7684scheme"));
      }
    }

    if (!_appParams.appleId) {
      throw new Error('请传入appleId');
    }
  } // 其它数据
  // 检查是否ios设备


  if ('ios' != _params.splatform) {
    alert('请用苹果设备打开本页面~');
    return false;
  }

  return true;
};
/* 3.调起相关的app或者打开appstore */

/* {
    appParams:{
        scheme,
        appleId,
        appid,
    },
    callback:function(opt){
        opt.isInstalled:是否安装指定应用  -1:不清楚   0:未安装  1:已安装，将不会调起appstore
        opt.isLaunched: 是否触发调起appstore的动作
        //idownloadtime：点击时间
        opt.launchRealValue:1/2/3
        isJump:false,//是否只能靠业务自行跳转
        launchRealValue=1 只保证点击执行
        launchRealValue=2 检测到离开当前页面
        launchRealValue=3 微信/手Q/浏览器告知拉起成功
    }//回调：
}*/


var launchApp = function launchApp(opt) {
  var cbRes = {
    isInstalled: false,
    isLaunched: false,
    launchRealValue: 1
  };
  var isCallbackDo = false; // 是否已经执行回调
  // 先判断是否安装

  jsBridge.app.isInstalled(function (res) {
    if (res) {
      // 已安装,则启动
      cbRes.isInstalled = true;
      jsBridge.app.launchApp(function () {
        isFunction(opt.callback) && opt.callback(cbRes);
      }, opt.appParams);
    } else {
      // 未安装，则拉起appstore
      // 检测离开页面：
      var vcId = jsBridge.ui.addVisibilityChangeEvent(function (res) {
        if (false == res.isVisible) {
          if (1 == cbRes.launchRealValue) {
            cbRes.isLaunched = true;
            cbRes.launchRealValue = 2; // console.log('leave page ok');

            if (!isCallbackDo) {
              isFunction(opt.callback) && opt.callback(cbRes);
            }
          }

          jsBridge.ui.removeVisibilityChangeEvent(vcId);
        }
      }); // 5s内有离开页面动作

      setTimeout(function () {
        jsBridge.ui.removeVisibilityChangeEvent(vcId);
      }, 5000);
      jsBridge.app.installApp(function (res) {
        if (res) {
          cbRes.isLaunched = true;
          cbRes.launchRealValue = 3;
          isCallbackDo = true;
          isFunction(opt.callback) && opt.callback(cbRes);
        } else {// 等待5s的离开判断
        }
      }, {
        appleId: opt.appParams.appleId,
        canJump: function canJump() {
          cbRes.isJump = true;
          isCallbackDo = true;
          isFunction(opt.callback) && opt.callback(cbRes);
          return false;
        }
      });
    }
  }, opt.appParams);
};
/* 4 获取登录态相关参数*/


var getLoginStatusParams = function getLoginStatusParams(cb) {
  var sAMSAcctype = '';
  var acctype = '';

  if (Cookie.get('acctype')) {
    sAMSAcctype = 'wx' == Cookie.get('acctype') ? 'wx' : 'qq';
    acctype = Cookie.get('acctype') || 'pt';
  }

  var suin = '';
  var sAMSAccessToken = '';
  var sAMSSourceAppId = '';

  if ('pt' == acctype) {
    suin = Cookie.get('uin');
    sAMSAccessToken = Cookie.get('skey');
  } else if ('wx' == acctype) {
    suin = Cookie.get('openid');
    sAMSSourceAppId = Cookie.get('appid');
    sAMSAccessToken = Cookie.get('access_token');
  } else if ('qc' == acctype) {
    suin = Cookie.get('openid');
    sAMSSourceAppId = Cookie.get('appid');
    sAMSAccessToken = Cookie.get('access_token');
  }

  isFunction(cb) && cb({
    userinfo: {
      sAMSAcctype: sAMSAcctype,
      suin: suin,
      sAMSAccessToken: sAMSAccessToken,
      sAMSSourceAppId: sAMSSourceAppId
    }
  });
};
/* 5.绑定相关事件*/


var bindEvents = function bindEvents(btns, self) {
  if (!btns) {
    return;
  }

  var arrBtns = [];

  if (isString(btns)) {
    arrBtns = [btns];
  } else if (isArray(btns)) {
    arrBtns = btns;
  } else {
    return;
  }

  for (var i = 0; i < arrBtns.length; i++) {
    var btn = arrBtns[i];
    g(btn).addEventListener('click', function () {
      var idownloadtime = getFormatDateTime(new Date()); // console.log('click ok','click time:',idownloadtime);
      // 点击时间

      self.reportParams.idownloadtime = idownloadtime;
      launchApp({
        appParams: self.appParams,
        callback: function callback(opt) {
          // console.log('launch ok',opt);
          reportAfterLaunch(opt, self);
        }
      });
    });
  }
};
/* 6.点击之后上报之前 */


var reportAfterLaunch = function reportAfterLaunch(opt, self) {
  if (opt.isJump) {
    // 先上报再跳转
    self.report({
      callback: function callback(res) {
        // 跳转appstore
        var appstoreUrl = "itms-apps://itunes.apple.com/app/id".concat(self.appParams.appleId);

        if (isFunction(self.downloadCallback)) {
          self.downloadCallback(res);
        }

        location.href = appstoreUrl;
      },
      launchOption: opt
    });
  } else if (opt.isInstalled || !opt.isLaunched) {
    // 已经安装应用或者未拉起appstore 不上报
    isFunction(self.downloadCallback) && self.downloadCallback({
      isInstalled: opt.isInstalled,
      isLaunched: opt.isLaunched,
      isReport: false
    });
    return;
  } // 拉起appstore 需要上报


  if (opt.isLaunched) {
    self.report({
      launchOption: opt
    });
  }
};
/* 7.上报 */

/* {
    data:{},
    keyId://是否从缓存中取出来上报的,如果是，则为key
    randomId:'',//重试用
    callback:function(){}
}*/


var reportData = function reportData(option) {
  if (!option) {
    return;
  }

  if (!option.randomId) {
    var randomId = "req_".concat(Math.ceil(Math.random() * 10000000));

    while (reportRequestPool[randomId]) {
      randomId = "req_".concat(Math.ceil(Math.random() * 10000000));
    }

    reportRequestPool[randomId] = {
      tryTimes: 0,
      status: 1
    };
    option.randomId = randomId;
  } // idownloadtime


  if (!option.data.idownloadtime) {
    option.data.idownloadtime = getFormatDateTime(new Date());
  } // 上报时间


  option.data.dtEventTime = getFormatDateTime(new Date()); // 发起上报请求

  Request.ajax({
    url: option.reportUrl,
    type: 'POST',
    dataType: 'json',
    timeout: 10000,
    // 10s超时
    data: JSON.stringify(option.data),
    contentType: 'application/json',

    /* headers:{
            'Content-Type':'application/json'
        },*/
    success: function success(result) {
      if (0 == result.iRet) {
        isFunction(option.callback) && option.callback({
          reportOK: true,
          result: result
        });
      } else {
        isFunction(option.callback) && option.callback({
          reportOK: false,
          result: result
        }); // throw(new Error('上报接口返回错误:\n'+result.sMsg));
      }
    },
    error: function error(xhr, errorType) {
      console.log('error', errorType); // 重试
      // eslint-disable-next-line no-plusplus

      if (++reportRequestPool[option.randomId].tryTimes < 3) {
        reportData(option); // 可以允许重试3次
      } else {
        // 上报失败存入缓存
        saveReportFailData({
          errorType: errorType,
          data: option.data
        }, option.keyId);
        isFunction(option.callback) && option.callback({
          reportOK: false,
          networkError: errorType
        });
      }
    },
    // eslint-disable-next-line no-unused-vars
    complete: function complete(xhr, status) {
      /* if('timtout' == status){
                console.log('timeout');
            }
            console.log('complete',status);*/
    }
  });
  /* console.log('上报中:','上报数据:',option.data);
    isFunction(option.callback) && option.callback({
        iRet:0,
        sMsg:'上报成功'
    });*/
};
/* 8.缓存上报失败的情况，下次再重试 */


var saveReportFailData = function saveReportFailData(opt, keyId) {
  try {
    // 先取旧数据
    var data = localStorage.getItem('milo_iosir_cache');
    var oData = {};

    if (data) {
      oData = JSON.parse(data);
    }

    if (!keyId) {
      keyId = "".concat(new Date().getTime());
    } // 判断是否已有数据


    if (oData[keyId]) {
      // eslint-disable-next-line no-plusplus
      oData[keyId].cacheTimes++;
    } else {
      opt.cacheTimes = 1;
      oData[keyId] = opt;
    } // 如果超过3次，则丢弃


    if (oData[keyId].cacheTimes > 3) {
      delete oData[keyId];
    } // 写入


    localStorage.setItem('milo_iosir_cache', JSON.stringify(oData));
  } catch (e) {
    throw new Error('operate localStorage failed');
  }
};
/* 9.获取缓存失败的数据 */


var getReportFailData = function getReportFailData() {
  try {
    // 先取旧数据
    var data = localStorage.getItem('milo_iosir_cache');
    var oData = {};

    if (data) {
      oData = JSON.parse(data);
    }

    return oData;
  } catch (e) {
    return {};
  }
};
/* 10.移除指定缓存失败数据 */


var removeReportFailData = function removeReportFailData(keyId) {
  try {
    // 先取旧数据
    var data = localStorage.getItem('milo_iosir_cache');
    var oData = {};

    if (data) {
      oData = JSON.parse(data);
    } // eslint-disable-next-line no-prototype-builtins


    if (oData.hasOwnProperty(keyId)) {
      delete oData[keyId];
      localStorage.setItem('milo_iosir_cache', JSON.stringify(oData));
    }

    return true;
  } catch (e) {
    return false;
  }
};
/*
	染色上报组件-JS侧
*/


var IOSInstallReport = /*#__PURE__*/function () {
  function IOSInstallReport(params) {
    _classCallCheck(this, IOSInstallReport);

    // 1 上报的参数
    this.reportParams = {}; // 2 app要用到的参数

    this.appParams = {}; // 3.downloadBtn

    this.downloadBtn = ''; // 3.downloadCallback

    this.downloadCallback = null;
    this.env = params.env;
    params = params || {}; // 先获取环境参数

    var pEnv = getEnviromentParams(); // test 打印到input中

    for (var k in pEnv) {
      if (isDom(g(k))) {
        g(k).value = pEnv[k];
      }
    } // 整合环境参数和


    this.reportParams = _objectSpread(_objectSpread({}, pEnv), params.reportData); // 整合app参数

    this.appParams = _objectSpread(_objectSpread({}, this.appParams), params.appData); // download

    this.downloadBtn = params.downloadBtn;
    this.downloadCallback = params.downloadCallback; // 检查参数
    // if(!checkParams(this.reportParams,this.appParams)){
    //     return;
    // }

    jsBridge.initPlatform(function () {}, this.appParams); // 绑定下载事件

    bindEvents(this.downloadBtn, this);
    this.reportCacheData();
  }
  /* 1 手动上报*/

  /*
    {
        launchOption:{}
        reportData:{},
        callback:function(){}
    }
    */


  _createClass(IOSInstallReport, [{
    key: "report",
    value: function report(option) {
      option = option || {}; // const self = this;

      var _callback = isFunction(option.callback) ? option.callback : this.downloadCallback;

      var reportParams = {};
      var launchOption = option.launchOption || null;
      var oRes = {};

      if (launchOption) {
        oRes.isInstalled = launchOption.isInstalled;
        oRes.isLaunched = launchOption.isLaunched;
        oRes.launchRealValue = launchOption.launchRealValue;
      }

      reportParams = _objectSpread(_objectSpread(_objectSpread({}, reportParams), this.reportParams), option.reportData);
      reportParams.sAMSTargetAppId = reportParams.sgameappid;

      if (!checkParams(reportParams)) {
        oRes.isReport = false;
        oRes.sError = '参数校验不通过';
        isFunction(_callback) && _callback(oRes);
        throw new Error('参数校验不通过');
      } // 获取登录态


      getLoginStatusParams(function (result) {
        // console.log('checkLogin success',result);
        reportParams = _objectSpread(_objectSpread({}, result.userinfo), reportParams);
        reportData({
          data: reportParams,
          randomId: '',
          reportUrl: reportCgi,
          callback: function callback(reportRes) {
            oRes.isReport = true;
            oRes.reportResult = reportRes;
            isFunction(_callback) && _callback(oRes);
          }
        });
      });
    }
    /* 2 绑定下载按钮*/

    /*
          downloadBtn: {string} 或 {array}
      */

  }, {
    key: "bindDownload",
    value: function bindDownload(downloadBtn) {
      bindEvents(downloadBtn, this);
    }
    /* 3 上报缓存的数据(上次上传失败的数据)*/

  }, {
    key: "reportCacheData",
    value: function reportCacheData() {
      // 先获取缓存数据
      var oCachedFailData = getReportFailData(); // 遍历

      var _loop = function _loop(keyId) {
        var opt = oCachedFailData[keyId]; // 重试

        reportData({
          data: opt.data,
          keyId: keyId,
          reportUrl: reportCgi,
          callback: function callback(result) {
            if (!result.networkError) {
              // 非网络错误，则消除本条缓存
              removeReportFailData(keyId);
            }
          }
        });
      };

      for (var keyId in oCachedFailData) {
        _loop(keyId);
      }
    }
  }]);

  return IOSInstallReport;
}();

export { IOSInstallReport as default };